module.exports = __webpack_public_path__ + "img/line-chart.d913e3f1.svg";